import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import Link from '@/components/Link';
import { colors } from '@/constants/theme';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';

function Tags() {
  const page = useTypedSelector(selectSinglePost);
  const parentRoute = useRouter().asPath.split('/')[1];

  if (!page || !page.tags || page.tags.length === 0) {
    return null;
  }

  return (
    <Component>
      {page.tags.map(({ tag, urlAlias }, index) => (
        <TagLink key={index} to={`/${parentRoute}?tag=${urlAlias}`}>
          {tag}
        </TagLink>
      ))}
    </Component>
  );
}

export default Tags;

const Component = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const TagLink = styled(Link)`
  font-size: 16px;
  line-height: 21px;
  margin: 0 10px 10px 0;
  padding: 10px;
  background: ${colors.gray400};
  border-radius: 15px;
  user-select: none;

  &:hover {
    background: ${colors.gray500};
  }
`;
